import ProductCompareTool from 'components/ProductPage/ProductCompareTool/ProductCompareTool';

export default ProductCompareTool;
